import Input from '../../../../../components/Input/Input';
import { phone as PHONE_MASK } from '../../../../../constants/mask';
import { textStyles } from '../../../../../constants/textStyles';
import { CAR_FIELDS, FLOW_ECP, PERSON_FIELDS, REQUISITES_FIELDS, fieldDomId, normalizePhone } from './form';
import { Fields, area, card, grid, hint, termsGrid, title } from './parts';

const ContractForm = ({ form, state, flow, isError, setField, setForm }) => (
  <>
    <div style={card}>
      <p style={title}>ÐÐ³ÐµÐ½Ñ</p>
      <p style={hint}>
        {state?.values?.agent?.name || 'ÐÐ¦'}
        {state?.values?.agent?.bin ? `, ÐÐÐ ${state.values.agent.bin}` : ''}
      </p>
      <div style={grid}>
        <Input
          id={fieldDomId('agent.director')}
          label="Ð Ð»Ð¸ÑÐµ"
          placeholder="ÐÑÐ¾ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ Ð·Ð° Ð¿Ð»Ð¾ÑÐ°Ð´ÐºÑ"
          value={form.agent.director}
          error={isError('agent', 'director')}
          handleSetState={(value) => setField('agent', 'director', value)}
        />
        <Input
          id={fieldDomId('agent.basis')}
          label="ÐÐ° Ð¾ÑÐ½Ð¾Ð²Ð°Ð½Ð¸Ð¸"
          placeholder="Ð£ÑÑÐ°Ð²Ð°"
          value={form.agent.basis}
          error={isError('agent', 'basis')}
          handleSetState={(value) => setField('agent', 'basis', value)}
        />
        {flow === FLOW_ECP && (
          <Input
            id={fieldDomId('agent.phone')}
            label="Ð¢ÐµÐ»ÐµÑÐ¾Ð½ Ð´Ð¸ÑÐµÐºÑÐ¾ÑÐ°"
            placeholder="+7 (___) ___-__-__"
            mask={PHONE_MASK}
            value={form.agent.phone}
            error={isError('agent', 'phone')}
            handleSetState={(value) => setField('agent', 'phone', normalizePhone(value))}
          />
        )}
      </div>
    </div>

    <div style={card}>
      <p style={title}>ÐÑÐ¾Ð´Ð°Ð²ÐµÑ</p>
      <div style={grid}>
        <Fields fields={PERSON_FIELDS} section="seller" form={form} isError={isError} onChange={setField} />
      </div>
    </div>

    <div style={card}>
      <p style={title}>ÐÐ¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ</p>
      <div style={grid}>
        <Fields fields={PERSON_FIELDS} section="buyer" form={form} isError={isError} onChange={setField} />
      </div>
    </div>

    <div style={card}>
      <p style={title}>ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ</p>
      <div style={grid}>
        <Fields fields={CAR_FIELDS} section="car" form={form} isError={isError} onChange={setField} />
      </div>
    </div>

    <div style={card}>
      <p style={title}>Ð¡ÑÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°</p>
      <div style={grid}>
        <Input
          id={fieldDomId('price')}
          label="Ð¡ÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ, â¸"
          value={form.price || ''}
          error={isError('price')}
          handleSetState={(value) => setForm((prev) => ({ ...prev, price: value.replace(/[^\d]/g, '') }))}
        />
        <Fields fields={REQUISITES_FIELDS} section="requisites" form={form} isError={isError} onChange={setField} />
      </div>
    </div>

    <div style={card}>
      <p style={title}>Ð¡ÑÐ¾ÐºÐ¸</p>
      <div style={termsGrid}>
        <Input
          id={fieldDomId('terms.agentFee')}
          label="ÐÐ¾Ð·Ð½Ð°Ð³ÑÐ°Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð³ÐµÐ½ÑÐ°, â¸ â ÑÐ´ÐµÑÐ¶Ð¸Ð²Ð°ÐµÑÑÑ Ð¸Ð· Ð²ÑÐ¿Ð»Ð°ÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÑ"
          value={form.terms.agentFee}
          error={isError('terms', 'agentFee')}
          handleSetState={(value) => setField('terms', 'agentFee', value.replace(/[^\d]/g, ''))}
        />
        <Input
          label="Ð¡ÑÐ¾Ðº Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð° Ð´ÐµÐ½ÐµÐ³ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÑ â Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¸Ñ Ð´Ð½ÐµÐ¹ Ð¿Ð¾ÑÐ»Ðµ Ð¿Ð¾ÑÑÑÐ¿Ð»ÐµÐ½Ð¸Ñ Ð¿Ð¾Ð»Ð½Ð¾Ð¹ Ð¾Ð¿Ð»Ð°ÑÑ Ð½Ð° ÑÑÑÑ Ð¿Ð»Ð¾ÑÐ°Ð´ÐºÐ¸"
          value={form.terms.payoutDays}
          handleSetState={(value) => setField('terms', 'payoutDays', value.replace(/[^\d]/g, ''))}
        />
        <Input
          label="Ð¡ÑÐ¾Ðº Ð¿ÐµÑÐµÐ´Ð°ÑÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ â ÐºÐ°Ð»ÐµÐ½Ð´Ð°ÑÐ½ÑÑ Ð´Ð½ÐµÐ¹ Ð¿Ð¾ÑÐ»Ðµ Ð¿Ð¾ÑÑÑÐ¿Ð»ÐµÐ½Ð¸Ñ Ð¿Ð¾Ð»Ð½Ð¾Ð¹ Ð¾Ð¿Ð»Ð°ÑÑ Ð½Ð° ÑÑÑÑ Ð¿Ð»Ð¾ÑÐ°Ð´ÐºÐ¸"
          value={form.terms.handoverDays}
          handleSetState={(value) => setField('terms', 'handoverDays', value.replace(/[^\d]/g, ''))}
        />
      </div>
      <label style={{ display: 'block', marginTop: 16 }}>
        <p style={{ ...textStyles.fieldLabel, marginBottom: 8 }}>ÐÐµÑÐµÐºÑÑ Ð°Ð²ÑÐ¾</p>
        <textarea
          value={form.terms.defects}
          placeholder="ÐÑÑÑÐ¾ â Ð² Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐµ Ð±ÑÐ´ÐµÑ Â«Ð½ÐµÐ´Ð¾ÑÑÐ°ÑÐºÐ¾Ð² Ð½Ðµ Ð²ÑÑÐ²Ð»ÐµÐ½Ð¾Â»"
          onChange={(e) => setField('terms', 'defects', e.target.value)}
          rows={3}
          style={area}
        />
      </label>
    </div>

    <div style={card}>
      <p style={title}>ÐÑÐ¸ Ð¿ÐµÑÐµÐ´Ð°ÑÐµ Ð°Ð²ÑÐ¾</p>
      <div style={termsGrid}>
        <Input
          label="ÐÐ»ÑÑÐ¸ Ð¾Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ, ÑÑ."
          placeholder="Ð¡ÐºÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ¾Ð² Ð¿ÐµÑÐµÐ´Ð°ÑÑ Ð²Ð¼ÐµÑÑÐµ Ñ Ð°Ð²ÑÐ¾"
          value={form.terms.keysCount}
          handleSetState={(value) => setField('terms', 'keysCount', value.replace(/[^\d]/g, ''))}
        />
      </div>
      <label style={{ display: 'block', marginTop: 16 }}>
        <p style={{ ...textStyles.fieldLabel, marginBottom: 8 }}>ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ðµ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ / ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ</p>
        <textarea
          value={form.terms.extraEquipment}
          placeholder="ÐÑÑÑÐ¾ â Ð² Ð°ÐºÑÐµ Ð¾ÑÑÐ°Ð½ÐµÑÑÑ Ð¿ÑÐ¾ÑÐµÑÐº"
          onChange={(e) => setField('terms', 'extraEquipment', e.target.value)}
          rows={2}
          style={area}
        />
      </label>
    </div>
  </>
);

export default ContractForm;
